import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';

import { bindAll } from '@bibliocommons/utils-react';
import FullScreenOverlay from '@bibliocommons/deprecated-base-full-screen-overlay';
import { ExpandableText } from '@bibliocommons/deprecated-expandable';
import { bibShape, userIdentityShape, ugcSummaryShape } from '@bibliocommons/bc-prop-types';

import { allowFreeText } from 'app/helpers/user';
import shelfItemShape from 'app/shapes/shelves/shelfItemShape';
import DisplayActions from '../DisplayActions';
import DisplayWrapper from '../DisplayWrapper';

import SummaryUGCEditor from '../UGCEditors/SummaryUGCEditor';

export default class SummaryDisplay extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);

    this.state = {
      showEditor: false
    };
  }

  openEditor() {
    this.setState({ showEditor: true });
  }

  closeEditor() {
    this.setState({ showEditor: false });
  }

  renderEditor() {
    return (
      this.state.showEditor && (
        <div>
          <SummaryUGCEditor
            bib={this.props.bib}
            shelfItem={this.props.shelfItem}
            handleClose={this.closeEditor}
            existingSummary={this.props.summary}
            summariesTransactions={this.props.summariesTransactions}
            shelfTransactions={this.props.shelfTransactions}
            summariesActions={this.props.summariesActions}
            shelfActions={this.props.shelfActions}
          />
        </div>
      )
    );
  }

  renderActions() {
    const { owner, bib, summary, summariesActions, summariesTransactions } = this.props;

    if (owner.get('loggedIn')) {
      const summaryId = summary.get('id');
      const metadataId = summary.get('metadataId');
      const title = bib.getIn(['briefInfo', 'title']);
      const handleRemove = () => summariesActions.removeSummary({ metadataId, summaryId });
      const isRemoving = summariesTransactions.getIn([metadataId, summaryId, 'isRemoving'], false);
      const editScreenReaderMessage = <FormattedMessage id="ada_ugc_edit_summary" values={{ title }} />;
      const removeScreenReaderMessage = <FormattedMessage id="ada_ugc_remove_summary" values={{ title }} />;

      return (
        <DisplayActions
          handleEdit={allowFreeText(owner) ? this.openEditor : undefined}
          handleRemove={handleRemove}
          isRemoving={isRemoving}
          editScreenReaderMessage={editScreenReaderMessage}
          removeScreenReaderMessage={removeScreenReaderMessage}
        />
      );
    }

    return null;
  }

  render() {
    return (
      <DisplayWrapper className="cp-ugc-summary-display">
        <ExpandableText text={this.props.summary.get('summary')} />
        {this.renderActions()}

        <FullScreenOverlay open={!!this.state.showEditor} handleClose={this.closeEditor}>
          {this.renderEditor()}
        </FullScreenOverlay>
      </DisplayWrapper>
    );
  }
}

SummaryDisplay.propTypes = {
  bib: bibShape.isRequired,
  shelfItem: shelfItemShape.isRequired,
  owner: userIdentityShape.isRequired,
  summary: ugcSummaryShape.isRequired,
  summariesTransactions: ImmutablePropTypes.map.isRequired,
  summariesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfTransactions: ImmutablePropTypes.map.isRequired
};
